function jcMakeBespokeTestiRow() {
  var bespoke = document.querySelector('.jc-bespoke-teaser');
  var testi = document.querySelector('.jc-testi');
  if (!bespoke || !testi) return;

  var bespokeSection = bespoke.closest('.shopify-section');
  var testiSection = testi.closest('.shopify-section');
  if (!bespokeSection || !testiSection) return;
  if (bespokeSection.parentElement.classList.contains('jc-side-by-side')) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'jc-side-by-side';
  bespokeSection.parentNode.insertBefore(wrapper, bespokeSection);
  wrapper.appendChild(bespokeSection);
  wrapper.appendChild(testiSection);
}

document.addEventListener('DOMContentLoaded', jcMakeBespokeTestiRow);

var jcRowObserver = new MutationObserver(function () {
  jcMakeBespokeTestiRow();
});
jcRowObserver.observe(document.body, { childList: true, subtree: true });